<template>
  <div class="main-content-container overflow-hidden">
    <ListItemVessel />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListItemVessel from "@/components/Pages/Management/ItemVessel/ListItemVessel.vue";

export default defineComponent({
  name: "ListItemVesselPage",
  components: {
    ListItemVessel,
  },
});
</script>
